import React from "react";
import { Link } from "react-router-dom";
import { MdCall } from "react-icons/md";
import { GrMail } from "react-icons/gr";
import { HiLocationMarker } from "react-icons/hi";
import { BsFillSuitHeartFill } from "react-icons/bs";
import instaLogo from "../../assets/img/instagram.png";
import whatsapp from '../../assets/img/WhatsApp_icon.png';
import facebook from '../../assets/img/facebook.png';
import youtube from '../../assets/img/youtube.png';
import Logo from '../../assets/img/Threads.png';
import Fssai from '../../assets/img/fssai-removebg-preview.png';
import Msme from '../../assets/img/msme-removebg-preview.png';
const Footer = () => {
  return (
    <>
      <footer style={{backgroundColor:"#88C273"}} id="tempaltemo_footer">
        <div className="container">
          <div className="row">
            <div className="col-md-4 pt-5">
              <h2 className="h2 text-success border-bottom pb-3 border-light logo">
                Vebbox
              </h2>
              <ul className="list-unstyled text-light footer-link-list">
                <li>
                  <HiLocationMarker className="me-2 mb-1 text-white" />
                  72, Second floor, Kumbeswaran
                  <br />
                 E St, South Street,
                  <br />
                  Kumbakonam, Tamil Nadu
                  <br />
                  612001
                </li>
                <li>
                  <MdCall className="me-2 mb-1" />
                  <a className="text-decoration-none text-white" href="tel:6379321835">
                    6379321835
                  </a>
                </li>
                <li>
                  <GrMail className="me-2 mb-1" />
                  <a
                    className="text-decoration-none text-white"
                    href="mailto:farmsivam@gmail.com"
                  >
                    info@vebbox.in
                  </a>
                </li>
                
                  
                 
                
                <li>
                <a
                    className="text-decoration-none text-white"
                    href="https://instagram.com/"
                    target="blank"
                  >
                   <img
                    src={instaLogo}
                    height="30px"
                    width="auto"
                    className="me-1 mt-0"
                    alt="sivamfarms instagram"
                  />
                  </a>&nbsp;&nbsp;&nbsp;&nbsp;
                  
                  <a
                    className="text-decoration-none"
                    href="https://wa.me/c/"
                    target="blank"
                  >
                   <img
                    src={whatsapp}
                    height="35px"
                    width="auto"
                    className="me-1 mt-0"
                    alt="sivamfarms whatsapp"
                  />
                  </a>&nbsp;&nbsp;&nbsp;&nbsp;
                 
                  <a
                    className="text-decoration-none"
                    href="https://www.facebook.com/"
                    target="blank"
                  >
                    <img
                    src={facebook}
                    height="35px"
                    width="auto"
                    className="me-1 mt-0"
                    alt="sivamfarms facebook"
                  />
                  </a>&nbsp;&nbsp;&nbsp;&nbsp;
                  <a
                    className="text-decoration-none"
                    href="https://youtube.com/"
                    target="blank"
                  >
                   <img
                    src={youtube}
                    height="35px"
                    width="auto"
                    className="me-1 mt-0"
                    alt="sivamfarms youtube"
                  />
                  </a>&nbsp;&nbsp;&nbsp;&nbsp;
                  <a
                    className="text-decoration-none"
                    href="https://www.threads.net/"
                    target="blank"
                  >
                   <img
                    src={Logo}
                    height="30px"
                    width="auto"
                    className="me-1 mt-0"
                    alt="sivamfarms youtube"
                  />
                  </a>
                </li>
               
              </ul>
            </div>

            <div className="col-md-4 pt-5">
              <h2 className="h2 text-light border-bottom pb-3 border-light">
                Products
              </h2>
              <ul className="list-unstyled text-light footer-link-list">
                <li>
                  <Link className="text-decoration-none text-white" to="/herbalProduct">
                   Fruits
                  </Link>
                </li>
                <li>
                  <Link className="text-decoration-none text-white" to="/gardenProduct">
                    Vegetables
                  </Link>
                </li>
                <li>
                  <Link className="text-decoration-none text-white" to="/foodProduct">
                   Others
                  </Link>
                </li>
                {/* <li>
                <img
                    src={Fssai}
                    height="40px"
                    width="auto"
                    className="me-1 mt-0"
                    alt="sivamfarms youtube"
                  />
                  
                </li>
                <li>
                <img
                    src={Msme}
                    height="35px"
                    width="auto"
                    className="me-1 mt-0"
                    alt="sivamfarms youtube"
                  />
                </li> */}
              </ul>
            </div>

            <div className="col-md-4 pt-5">
              <h2 className="h2 text-light border-bottom pb-3 border-light">
                Further Info
              </h2>
              <ul className="list-unstyled text-light footer-link-list">
                <li>
                  <Link className="text-decoration-none text-white" to="/">
                    Home
                  </Link>
                </li>
                <li>
                  <Link className="text-decoration-none text-white" to="/about">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link className="text-decoration-none text-white" to="/policy">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link className="text-decoration-none text-white" to="/terms">
                    Terms and Conditions
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="w-100 bg-black py-3">
          <div className="container">
            <div className="row pt-2">
              <div className="d-flex justify-content-between col-12">
                <p className="text-left text-light">
                  Copyright &copy; 2025 Vebbox
                </p>
                <a
                  href="https://vebbox.com/"
                  className="text-decoration-none text-light"
                >
                  Developed by vebbox software solutions with passion
                  <BsFillSuitHeartFill
                    className="ms-1"
                    style={{ color: "#c0392b", marginTop: "-5px" }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
export default Footer;
